import React, { createContext, useEffect, useState } from "react";

// service
import { MotivationalService } from "../services";

// context
import { useAuth } from "../hooks";

const {
  fetchSavedMotivationalQuote,
  saveMotivationalQuote,
  fetchAllMotivationalQuotes,
  deleteSavedMotivationalQuote,
} = MotivationalService;

const MotivationalContext = createContext({});

const Provider = ({ children }) => {
  const { phoneNumber: msisdn } = useAuth();

  const [bookmarkedItems, setBookmarkedItems] = useState([]);
  const [motivationalQuotes, setMotivationalQuotes] = useState([]);

  useEffect(() => {}, []);

  const addBookmark = async (item) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));

      const { data } = await saveMotivationalQuote({ payload: item, token });

      getUserMotivationalQuotes();
    } catch (e) {}
  };

  const removeBookmark = async (item) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));

      const { data } = await deleteSavedMotivationalQuote({
        token,
        _id: item._id,
      });

      getUserMotivationalQuotes();
    } catch (e) {}
  };

  const getAllMotivationalQuotes = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));

      const { data } = await fetchAllMotivationalQuotes({
        token,
      });

      setMotivationalQuotes(data);
    } catch (e) {}
  };

  const getUserMotivationalQuotes = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));

      const { data } = await fetchSavedMotivationalQuote({
        token,
        msisdn,
      });

      setBookmarkedItems(data.motivations);
    } catch (e) {}
  };

  return (
    <MotivationalContext.Provider
      value={{
        bookmarkedItems,
        addBookmark,
        removeBookmark,
        motivationalQuotes,
        getAllMotivationalQuotes,
        getUserMotivationalQuotes,
      }}
    >
      {children}
    </MotivationalContext.Provider>
  );
};

MotivationalContext.ProviderWrapper = Provider;

export default MotivationalContext;
